import styled from 'styled-components'
import { Icon, Text } from '@amzn/storm-ui'
import { AdvertiserReportExport } from './advertiser_report_export'

export const StyledAdvertiserReportExport = styled(AdvertiserReportExport)`
  padding-inline-start: ${({ theme }) => theme.spacing.small};
`
export const NewlineInfoTip = styled(Text)`
  white-space: pre-wrap;
`
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const AdvertisersBody = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
`
export const StyledTableContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.mini};
  width: 100%;
  td,
  th {
    border-inline-end: 0px;
  }
`

export const ExportReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: flex-end;
`

export const ReportStatusContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.micro};
`

export const DownloadIcon = styled(Icon)`
  margin-right: ${({ theme }) => theme.spacing.micro};
`

export const AdvertisersModalText = styled(Text)`
  width: 450px;
`
